import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {ClienteModel} from '../../../models/vmi-clienteModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-clientes',
  templateUrl: './vmi-frm-mantenedor-clientes.component.html',
  styleUrls: ['./vmi-frm-mantenedor-clientes.component.css']
})
export class VmiFrmMantenedorClientesComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: ClienteModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  cmbEstado: any[] = [
    {clave: 1, valor: 'ACTIVO'},
    {clave: 0, valor: 'INACTIVO'}
  ];

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _clientes: VmiClientesService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.clientes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      cliId: [''],
      cliRuc: ['', [Validators.required]],
      cliNombre: ['', [Validators.required]],
      cliEmail: ['', [Validators.required]],
      cliFono: ['', [Validators.required]],
      cliDir: ['', [Validators.required]],
      cliEstado: ['', [Validators.required]],
      cliCodigobaan: ['', [Validators.required]],
      // cliConsumoTotal: ['', [Validators.required]],
      // cliConsumido: ['', [Validators.required]],
      // cliFechaInicioContrato: ['', [Validators.required]],
      // cliFechaFinContrato: ['', [Validators.required]],
    });
    this.gridComponent();
    this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this._clientes.getAll().subscribe((res: ClienteModel[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'cliId',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CÓDIGO BAAN',
        field: 'cliCodigobaan',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'RUC',
        field: 'cliRuc',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'NOMBRE',
        field: 'cliNombre',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'EMAIL',
        field: 'cliEmail',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'TELÉFONO',
        field: 'cliFono',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'DIRECCIÓN',
        field: 'cliDir',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const obj = {
      cliId: rowData.cliId,
      cliRuc: rowData.cliRuc,
      cliNombre: rowData.cliNombre,
      cliEmail: rowData.cliEmail,
      cliFono: rowData.cliFono,
      cliDir: rowData.cliDir,
      cliEstado: rowData.cliEstado,
      cliCodigobaan: rowData.cliCodigobaan
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const obj: ClienteModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._clientes.delete(obj.cliId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const obj: ClienteModel = this.formulario.value;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._clientes.create(obj),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const obj: ClienteModel = this.formulario.value;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._clientes.edit(obj),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
